import React from 'react';
import Header from '../components/site/Header';
import Footer from '../components/site/Footer';
import BookHero from '../components/book/BookHero';
import BookShifts from '../components/book/BookShifts';
import BookBonuses from '../components/book/BookBonuses';
import BookProof from '../components/book/BookProof';
import BookFinale from '../components/book/BookFinale';

// Razorpay payment link for the book (₹399 + 6 free bonuses)
const BOOK_PAYMENT_LINK = 'https://rzp.io/rzp/BjNkIh66';

export default function BookPage() {
  return (
    <>
      <Header />
      <main>
        <BookHero paymentLink={BOOK_PAYMENT_LINK} />
        <BookShifts />
        <BookBonuses paymentLink={BOOK_PAYMENT_LINK} />
        <BookProof />
        <BookFinale paymentLink={BOOK_PAYMENT_LINK} />
      </main>
      <Footer />
    </>
  );
}
